import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(5),
  },
}))

const Help = ({

}) => {
  const classes = useStyles()

  return (
    <div className={ classes.root }>
      <Typography variant="h6">
        Help
      </Typography>
      <Typography gutterBottom>
        The homepage shows a list of your projects.  You can add and delete your projects from this page.
      </Typography>
      <Typography gutterBottom>
        If you edit a project - you will see the list of items in that project.
      </Typography>
      <Typography gutterBottom>
        You can drag and drop the items in the list to control the order of the items.
      </Typography>
      <Typography gutterBottom>
        You can edit an item to change it's text or colour or delete it from the list.
      </Typography>
      <Typography gutterBottom>
        Things are saved automatically as you work but they are saved <strong>on your computer</strong>.
      </Typography>
      <Typography gutterBottom>
        This means, if you use a different computer - you will not see your project list.
      </Typography>
      <Typography gutterBottom>
        You can <strong>export</strong> a project which will download a file you can then <strong>import</strong> on another computer.
      </Typography>
    </div>
  )
}

export default Help